import { FormattedMessage } from 'react-intl'
import { useDispatch, useSelector } from 'react-redux'

// Selectors
import { selectCustomerFirstName } from '../../../../../../../../store/selectors/customerProfile'
import {
  selectScheduleTourDate,
  setScheduleTourDataToInitialState,
  selectScheduleTourStep,
  setScheduleTourShowModal,
  setScheduleTourStep,
  STEPS,
  STEPS_CONST,
} from '../../../../../../../../store/slices/scheduleTour'
import { selectListing } from '../../../../../../../../store/selectors/listings'

// Context
import { useTheme } from '@homebot/shared-ui-swashbuckle'

// Components
import { Text, CustomerAvatar } from '../../../../../../..'
import Step from '../../../../../ModalStepsOutline'

// Styles
import styles from './Confirmation.module.scss'
import { format } from 'date-fns'

export const Confirmation = () => {
  const customerFirstName = useSelector(selectCustomerFirstName)
  const listing = useSelector(selectListing)
  const currentStep = useSelector(selectScheduleTourStep)
  const stepIndex = STEPS.indexOf(currentStep)
  const tourDate = useSelector(selectScheduleTourDate)
  const { theme } = useTheme()
  const dispatch = useDispatch()

  return (
    <Step stepLabel='schedule-tour-confirmation'>
      <Step.HeaderNavSection
        currentStep={currentStep}
        steps={STEPS}
        onCancel={() => dispatch(setScheduleTourShowModal(false))}
        onBack={() => dispatch(setScheduleTourStep(STEPS_CONST[stepIndex - 1]))}
      >
        <FormattedMessage
          id='ScheduleTour.confirmation.header'
          defaultMessage='Tour request sent!'
        />
      </Step.HeaderNavSection>
      <Step.Body className={styles.body}>
        <CustomerAvatar className={styles.avatar} />
        <Text
          className={styles.title}
          element='div'
          weight='bold'
          variant='neutralCool'
          variantCount='900'
        >
          <FormattedMessage
            id='ScheduleTour.confirmation.title'
            defaultMessage='{customerFirstName} will be in touch shortly!'
            values={{ customerFirstName }}
          />
        </Text>
        <Text
          className={styles.copy}
          element='div'
          variant='neutralCool'
          variantCount='900'
        >
          <FormattedMessage
            id='ScheduleTour.confirmation.copy'
            defaultMessage='{customerFirstName} will follow up to finalize a date and time for your tour. If you have any questions, please contact them.'
            values={{ customerFirstName }}
          />
        </Text>

        <div
          style={{
            backgroundImage: `url(${listing.imageCoverUrl})`,
          }}
          className={styles.image}
        >
          <div className={styles.gradient}>
            <div className={styles.text}>
              <Text
                element='span'
                variant='neutralCool'
                variantCount={theme.isLightThemeType ? '100' : '800'}
                size='s'
              >
                <FormattedMessage
                  id='ScheduleTour.confirmation.date'
                  defaultMessage='Requested tour date'
                />
              </Text>
              <Text element='span' variant='white' weight='bold'>
                {format(tourDate, 'MMMM do, y')}
              </Text>
            </div>
          </div>
        </div>
      </Step.Body>
      <Step.FooterButton
        onClick={() => {
          dispatch(setScheduleTourDataToInitialState())
        }}
      >
        <FormattedMessage
          id='ScheduleTour.FooterButton.BackToListing'
          defaultMessage='Back to Listing'
        />
      </Step.FooterButton>
    </Step>
  )
}
